import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    baseurl: 'http://covusanm.offshoremedia.net',
    //baseurl: 'http://testcovusanm.sinoing.net'
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
